import 'ag-grid-enterprise';

import { GridApi } from '@ag-grid-enterprise/all-modules';
import React, { Dispatch, useEffect } from 'react';

import { useIsMount } from '../../../hooks/useOnChange';
import { TableGridProps } from '../TableGrid';
import { useTableGridApiDispatch, useTableGridApiState } from './TableGridApiContext';
import { TableGridApiAction, TableGridApiActions } from './TableGridApiContext.types';

export interface Props extends Partial<TableGridProps> {
  gridApi: GridApi | null;
  children: React.ReactNode;
}

const TableGridApiContextConstructor: React.FC<Props> = ({
  gridApi,
  rowSelectionIdGetter,
  onSelectionChanged,
  rowSelection,
  initialSelectedRows,
  refreshTable,
  children,
}) => {
  const dispatchTableApi = useTableGridApiDispatch();
  const { selectedRows } = useTableGridApiState();
  const isFirstMount = useIsMount();

  useEffect(() => {
    if (gridApi) {
      dispatchTableApi({
        type: TableGridApiAction.SetTableApi,
        payload: {
          tableGridApi: gridApi,
          rowSelectionIdGetter,
        },
      });

      if (typeof refreshTable === 'function') {
        refreshTableFn(gridApi, dispatchTableApi);
      }

      if (rowSelection && Array.isArray(initialSelectedRows)) {
        dispatchTableApi({
          type: TableGridApiAction.SetInitialSelectedRows,
          payload: initialSelectedRows,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridApi]);

  useEffect(() => {
    if (gridApi && !isFirstMount && typeof onSelectionChanged === 'function') {
      onSelectionChanged(selectedRows);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRows]);

  return <>{children}</>;
};

export const refreshTableFn = (api: GridApi, dispatchTableApi: Dispatch<TableGridApiActions>) => {
  dispatchTableApi({ type: TableGridApiAction.ResetSelectedRows });

  if (api) {
    /* to be used with ag-grid > v25
    api.onFilterChanged();
    */
    api.dispatchEvent({
      type: 'filterChanged',
    });
  }
};

export default TableGridApiContextConstructor;
